import { getApiUrl } from '../../utils/config';
import storePng from '@ui/assets/store.png';
import * as moment from 'moment';
import { EntityCard } from '@ui/components';
import * as React from 'react';
import { Icon } from 'antd';
import { IStore } from '@ui/api/v2/store.api';

const MapStatusIcons = {
  success: <Icon type="arrow-right" style={{ color: '#00cb07', fontWeight: 'bold' }} />,
  fail: <Icon type="reload" style={{ color: '#d90000', fontWeight: 'bold' }} />,
};

interface IProps {
  store: IStore;
}

export function Store({
  store: { id, name, address, phone, firstName, lastName, firstContactPhone, secondContactPhone, lastRequest, photo },
}: IProps) {
  return (
    <EntityCard>
      <div className="city-store-card-panel">
        <div className="city-store-card-panel__photo">
          {photo ? (
            <img
              className="city-store-card-panel__photo__img"
              src={`${getApiUrl()}/store/${id}/get-photo`}
              height="120px"
              alt=""
            />
          ) : (
            <img className="city-store-card-panel__photo__img" src={storePng} height="100%" alt="" />
          )}
        </div>
        <div className="city-store-card-panel__info">
          <div className="city-store-card-panel__info__name">{name}</div>
          <div className="city-store-card-panel__info__address">{address}</div>
          <div className="city-store-card-panel__info__phone">
            <a href={`tel:${phone}`}>{phone}</a>
          </div>
        </div>
        <div className="city-store-card-panel__contact">
          <div className="city-store-card-panel__contact__name">
            <span>{firstName}</span>
            <span>{lastName}</span>
          </div>
          <div className="city-store-card-panel__contact__phone">
            <a href={`tel:${firstContactPhone}`}>{firstContactPhone}</a>
            <a href={`tel:${secondContactPhone}`}>{secondContactPhone}</a>
          </div>
        </div>
        {lastRequest && (
          <div className="city-store-card-panel__last-request">
            <div className="city-store-card-panel__last-request__login">
              <span>{lastRequest.user ? lastRequest.user.login : 'менеджер удален'}</span>
              <span>{MapStatusIcons[lastRequest.status]}</span>
            </div>
            <div className="city-store-card-panel__last-request__updated">
              <span>{moment(lastRequest.updated).format('DD.MM.YYYY')}</span>
            </div>
          </div>
        )}
      </div>
    </EntityCard>
  );
}



// WEBPACK FOOTER //
// ./src/components/Report/Store.tsx